import { useOnboardingContext } from '../../use-onboarding-context'
import useGetHelpdeskParams from '../use-helpdesk-params'

export const useGetOnboardingSupportContactInfo = () => {
  const { onboardingInfo } = useOnboardingContext()
  const { data, isLoading } = useGetHelpdeskParams()
  const supportEmail = onboardingInfo.wholesaler?.SupportEmail || data?.Email
  const supportPhoneNumber = onboardingInfo.wholesaler?.SupportPhoneNumber || data?.PhoneNumber
  return {
    supportEmail,
    supportPhoneNumber,
    isLoading
  }
}
